import { defineRoute } from "src/routing/defineRoute";
import { developmentRoute } from "src/routing/domains/developments/detail/developmentDetailPaths";

/**
 * Path + typed URL builder pairs for development procurement / purchase-order routes.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const developmentProcurementRoute = defineRoute(`${developmentRoute.path}/procurement`);
export const developmentContractRoute = defineRoute(`${developmentRoute.path}/procurement/:bidContractRevisionId`);
export const developmentContractOverviewRoute = defineRoute(
  `${developmentRoute.path}/procurement/:bidContractRevisionId/overview`,
);
export const developmentContractLineItemsRoute = defineRoute(
  `${developmentRoute.path}/procurement/:bidContractRevisionId/line-items`,
);
export const developmentUnitPricingRoute = defineRoute(
  `${developmentRoute.path}/procurement/:bidContractRevisionId/unit-pricing`,
);
export const developmentContractPurchaseOrdersRoute = defineRoute(
  `${developmentRoute.path}/procurement/:bidContractRevisionId/purchase-orders`,
);
export const developmentPurchaseOrdersRoute = defineRoute(`${developmentRoute.path}/purchase-orders`);
export const developmentBidPackagesRoute = defineRoute(`${developmentRoute.path}/bid-packages`);
export const developmentBidPackageRoute = defineRoute(`${developmentRoute.path}/bid-packages/:bidPackageId`);
